<template>
  <div>
<!--    <div  v-if="formId === 'AuditWorkflow'">
      <audit-workflow-form ref="applicationModel" :formNo="formNo" formCode="AuditWorkflow"></audit-workflow-form>
    </div>
    <div v-if="formId === 'PutOnRecordWorkflow'">
      <put-on-record-workflow-form ref="applicationModel" :formNo="formNo" formCode="PutOnRecordWorkflow" ></put-on-record-workflow-form>
    </div>-->
    <!--<div v-if="formId === 'energy_meCert'">
      <energy-me-form-form-sign :formNo="formNo" formCode="energy_meCert"/>
      <a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol">
      </a-form-model-item>
    </div>
    <div v-if="formId === 'energy_ghgEmissionCert'">
      <EnergyGHGEmissionApplySignDetails :formNo="formNo" formCode="energy_ghgEmissionCert"/>
      <a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol"/>
    </div>
    <div v-if="formId === 'energy_energyMSCert'">
      <EnergyMsApplySignDetails :formNo="formNo" formCode="energy_energyMSCert"/>
      <a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol"/>
    </div>
    <div v-if="formId === 'use_power_apply'">
      <EnergyUeApplyFormSign :formNo="formNo" formCode="use_power_apply"/>
      <a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol"/>
    </div>
    <div v-if="formId === 'trade_result_apply'">
      <EnergyUeResultFormSign :formNo="formNo" formCode="trade_result_apply"/>
      <a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol"/>
    </div>
    <div v-if="formId === 'consumption_statistics_apply' || formId === 'consumption_statistics_change_apply'">
      <EnergyCsApplyFormSign :formNo="formNo"/>
      <a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol"/>
    </div>-->
  </div>
</template>

<script>
    export default {
      name: "DetailsModal",
      components: {
      },
      props: {
        formId: {
          type: String,
          required: true
        },
        formNo: {
          type: String,
          required: true
        }
      },
      data() {
        return {
          // formId:'',
          // formNo:'',
          labelCol: {
            xs: {span: 24},
            sm: {span: 6},
          },
          wrapperCol: {
            xs: {span: 24},
            sm: {span: 16},
          },
        }
      },
      methods: {

      }
    }
</script>

<style scoped>

</style>